module.exports = __webpack_public_path__ + "static/media/trending_hero_mobile.d8536e68.png";